import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MATERIAL_SANITY_CHECKS } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { F3LoadingModule } from './services/loading';
import { F3MediaWatcherModule } from './services/media-watcher';
import { F3UtilsModule } from './services/utils';

@NgModule({
    imports  : [
        // FuseConfirmationModule,
        // FuseLoadingModule,
        // FuseMediaWatcherModule,
        // FuseSplashScreenModule,
        // FuseUtilsModule

        // TODO add in splash screen and cofniramtion module
        
        F3LoadingModule,
        F3MediaWatcherModule,
        F3UtilsModule

    ],
    providers: [
        {
            // Disable 'theme' sanity check
            provide : MATERIAL_SANITY_CHECKS,
            useValue: {
                doctype: true,
                theme  : false,
                version: true
            }
        },
        {
            // Use the 'fill' appearance on Angular Material form fields by default
            provide : MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'fill'
            }
        }
    ]
})
export class F3Module
{
    /**
     * Constructor
     */
    constructor(@Optional() @SkipSelf() parentModule?: F3Module)
    {
        if ( parentModule )
        {
            throw new Error('F3Module has already been loaded. Import this module in the AppModule only!');
        }
    }
}
